/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './uploadBlob.defs.js'
export { main as default } from './uploadBlob.defs.js'
